import { cn } from '@src/lib/utils';

import {
    DateAiChatCalendarButton,
    DateAiChatLabel,
    dateAiChatControlClass,
    dateAiChatFormClass,
} from './ProcessFieldDateAiChatAppearance';
import { useDateAiChatPlaceholder } from './useDateAiChatPlaceholder';

import {
    ShadcnFormDatePickerFlow,
    type ShadcnFormDatePickerFlowProps,
} from '@shadcn-features/core/ShadcnForm/fields/ShadcnFormDatePickerFlow';

export function ProcessFieldDatePickerAiChat({
    label,
    className,
    fieldProps,
    format,
    placeholder,
    disabled,
    ...props
}: ShadcnFormDatePickerFlowProps) {
    const datePlaceholder = useDateAiChatPlaceholder(
        format || undefined,
        props.picker,
    );
    return (
        <ShadcnFormDatePickerFlow
            {...props}
            disabled={disabled}
            format={format || undefined}
            placeholder={placeholder ?? datePlaceholder}
            label={label && <DateAiChatLabel>{label}</DateAiChatLabel>}
            className={cn(dateAiChatFormClass, className)}
            fieldProps={{
                ...fieldProps,
                className: cn(
                    dateAiChatControlClass,
                    '[&>input]:placeholder:text-(--color-neutral-6)!',
                    fieldProps?.className,
                ),
                renderSuffix: (open) => (
                    <DateAiChatCalendarButton open={open} disabled={disabled} />
                ),
            }}
        />
    );
}
